export default __webpack_public_path__ + "static/media/in.f45d020f.svg";